import {useCallback, useEffect, useRef, useState} from 'react'

export function useAsyncValue<T>(
  initialValue: T,
  factory: () => Promise<T>,
  dependencies: any[] = [],
  fetchOnRender = true
) {
  const [value, setValue] = useState(initialValue)
  const [isLoading, setLoading] = useState(fetchOnRender)
  const [error, setError] = useState(null as Error | null)
  const [reloadToken, setReloadToken] = useState(0)
  const reload = useCallback(() => {
    setReloadToken((current) => current + 1)
  }, [setReloadToken])
  const renderedOnceRef = useRef(false)
  useEffect(() => {
    ;(async () => {
      if (!fetchOnRender && !renderedOnceRef.current) {
        renderedOnceRef.current = true
        return
      }

      renderedOnceRef.current = true

      try {
        setLoading(true)
        const newValue = await factory()
        setValue(newValue)
      } catch (e) {
        setError(e)
      } finally {
        setLoading(false)
      }
    })()
  }, [...(dependencies || []), reloadToken])
  return {value, isLoading, error, reload}
}
